"use client";

/**
 * AnalyticsProvider — mounts once near the root and initializes PostHog.
 *
 * When NEXT_PUBLIC_POSTHOG_KEY is absent this renders nothing and does
 * nothing: initAnalytics() short-circuits, so there is no network request,
 * no cookie, no crash. When the key is present it boots PostHog once and
 * fires a single landing_view on first mount.
 *
 * Wire it into the root layout (see wiringNeeded). It renders no DOM, so it
 * is safe to drop anywhere inside <body>.
 */

import { useEffect } from "react";
import {
  initAnalytics,
  track,
  ANALYTICS_EVENTS,
  analyticsEnabled,
} from "@/lib/analytics";

export function AnalyticsProvider() {
  useEffect(() => {
    if (!analyticsEnabled()) return;
    let cancelled = false;
    void initAnalytics().then(() => {
      if (cancelled) return;
      track(ANALYTICS_EVENTS.LANDING_VIEW);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
